export enum RequestStatusEnum {
  New = 10,
  Canceled = 1,
  Pended = 2,
  Completed = 3,
  InProgress = 4,
  Rejected = 5,
  Prepared = 6,
}
